/** 展示与埋点共用判断，避免只有接口标记、没有实际文案时误报。 */
export function getYearLowestPriceText(product?: unknown): string {
  if (
    !product ||
    typeof product !== 'object' ||
    !('is_year_lowest_price' in product) ||
    product.is_year_lowest_price !== true ||
    !('year_lowest_price_text' in product) ||
    typeof product.year_lowest_price_text !== 'string'
  )
    return '';
  return product.year_lowest_price_text.trim();
}

export function getYearLowestPriceTrackingProperties(product?: unknown) {
  return getYearLowestPriceText(product) ? { Lowest_Price: true } : {};
}
